export const CheckNan = {
    methods: {
        CheckNan(amount) {
            return isNaN(amount) ||
                amount == "" ||
                amount == null ||
                typeof amount == "undefined" ?
                0 :
                parseFloat(amount);
        }
    }
}